import { Typography } from "@mui/material";

import type { TypographyProps } from "@mui/material";
import type { FC } from "react";

interface EllipsisTextProps extends TypographyProps {
  text: string;
  lines?: number;
}
export const EllipsisText: FC<EllipsisTextProps> = ({ text, lines, ...props }) => (
  <Typography
    {...props}
    sx={[
      {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: lines,
        LineClamp: lines,
        WebkitBoxOrient: "vertical",
      },
      ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
    ]}
  >
    {text}
  </Typography>
);
